import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d99d938e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "overlay" }
const _hoisted_2 = { class: "overlay-right" }
const _hoisted_3 = { class: "overlay-right-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"bold"} }, "任务详情", -1))
const _hoisted_5 = {
  key: 0,
  class: "rectitle"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rectitle-text" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"16px","color":"#ea0d0d"} }, "不可结算"),
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"14px"} }, " 数据检测不合格，系统已自动拦截 ")
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-warning",
  style: {"color":"#ff4949"}
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bold"} }, "图片查重提示：", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#ff4949"} }, "*", -1))
const _hoisted_11 = { class: "overlay-right-main__reuqire" }
const _hoisted_12 = { class: "overlay-right-main__reuqire-item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "终端服务人员：", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin":"0 1px"} }, null, -1))
const _hoisted_15 = { class: "overlay-right-main__reuqire-item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "任务提交时间：", -1))
const _hoisted_17 = {
  key: 0,
  class: "overlay-right-main__reuqire-item"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "结算金额：", -1))
const _hoisted_19 = { class: "overlay-right-main__info" }
const _hoisted_20 = { class: "overlay-right-main__info-item" }
const _hoisted_21 = {
  key: 0,
  class: "ai-verdict-panel"
}
const _hoisted_22 = { class: "ai-vp-head" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ai-vp-head-icon" }, "🤖", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ai-vp-head-title" }, "智能辅助审核结果", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ai-vp-head-spacer" }, null, -1))
const _hoisted_26 = { class: "ai-vp-conclusion" }
const _hoisted_27 = { class: "ai-vp-body" }
const _hoisted_28 = { class: "ai-stage-row" }
const _hoisted_29 = {
  key: 0,
  class: "ai-stage"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ai-stage-t" }, "① 单条审核", -1))
const _hoisted_31 = { class: "ai-verdict-icon" }
const _hoisted_32 = { class: "ai-stage-sum" }
const _hoisted_33 = { class: "ai-stage-time" }
const _hoisted_34 = {
  key: 1,
  class: "ai-stage"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ai-stage-t" }, "② 批量审核", -1))
const _hoisted_36 = { class: "ai-stage-sum" }
const _hoisted_37 = { class: "ai-stage-time" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"margin":"24px 0"} }, "问卷详情", -1))
const _hoisted_39 = {
  key: 0,
  class: "overlay-right-footer"
}
const _hoisted_40 = { class: "overlay-left" }

import { watch, ref, nextTick, computed, onMounted, onUnmounted } from 'vue';
import { storeToRefs } from 'pinia';
import {
  AI_AUDIT_RESULT,
  AiAuditResult
} from '@/common/constants/intelligent-audit';
import { BaseSvg } from '@/components/base/base-svg/index';
import { useTaskAudit } from '../hooks/useTaskAudit';
import {
  BaseButton,
  BaseImageViewer,
  BaseRow,
  createDialog
} from 'xrk-components';
import { questionDetailComps } from '../components/question-detail-comps';
import { ProjectType } from '../types';
import { formatter } from '@/utils';
import {
  taskRecordUpdateMap,
  selectSimilartList,
  taskRecordDetail
} from '../data-source/apis';
import DeefMap from './deef-map.vue';
import CPreview from './c-preview.vue';
import RepeatPickure from './repeat-pickure.vue';

import appStore from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'task-detail',
  props: {
    id: {},
    dataState: {},
    projectId: {},
    projectType: {},
    searchVal: {},
    remove: {},
    canAudit: { type: Boolean },
    isShowMapHandleBtn: { type: Boolean, default: true }
  },
  emits: ['auditOver', 'refresh'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// 工业-1 服务商-2 供应商-3
const { defaultUserFnCode } = storeToRefs(appStore.useUserStoreSetup);

/**
 * 是否是服务商
 */
const isAsp = computed(() => defaultUserFnCode.value === 2);
/**
 * 是否是工业
 */
// const isIndustry = computed(() => defaultUserFnCode.value === 1);

/* ------------ 智能综合审核结论（仅服务商显示） ------------ */
const aiConclusionData = computed<any>(
  () => taskDetail.value?.aiAuditConclusion
);
const AI_RESULT_META: Record<
  number,
  {
    label: string;
    icon: string;
    cls: 'ai-pass' | 'ai-warn' | 'ai-reject';
    pillCls: 'pass' | 'review' | 'reject';
  }
> = {
  [AiAuditResult.Failed]: {
    label: '审核失败',
    icon: '!',
    cls: 'ai-warn',
    pillCls: 'reject'
  },
  [AiAuditResult.Pass]: {
    label: AI_AUDIT_RESULT[AiAuditResult.Pass].label,
    icon: '✓',
    cls: 'ai-pass',
    pillCls: 'pass'
  },
  [AiAuditResult.Reject]: {
    label: AI_AUDIT_RESULT[AiAuditResult.Reject].label,
    icon: '✕',
    cls: 'ai-reject',
    pillCls: 'reject'
  },
  [AiAuditResult.Doubt]: {
    label: AI_AUDIT_RESULT[AiAuditResult.Doubt].label,
    icon: '!',
    cls: 'ai-warn',
    pillCls: 'review'
  }
};
const FALLBACK_THEME = { label: '', icon: '!', cls: 'ai-warn' as const };
const initTheme = computed(
  () =>
    AI_RESULT_META[aiConclusionData.value?.aspStatus as number] ||
    FALLBACK_THEME
);
const summaryTheme = computed(
  () =>
    AI_RESULT_META[aiConclusionData.value?.overallStatus as number] ||
    FALLBACK_THEME
);
const finalBatchPill = computed(() => {
  const meta = AI_RESULT_META[aiConclusionData.value?.ossStatus as number];
  if (!meta) return { cls: 'reject' as const, label: '' };
  return { cls: meta.pillCls, label: meta.label };
});
const aiInitSummary = computed(() => aiConclusionData.value?.aspOpinion || '—');
const aiFinalSummary = computed(
  () => aiConclusionData.value?.ossOpinion || '—'
);
const _aiReasonList = computed<Array<{ title: string; desc?: string }>>(() => {
  const list = (aiConclusionData.value?.reasons || []) as Array<{
    riskTitle?: string;
    riskContent?: string;
  }>;
  return list.map(r => ({ title: r.riskTitle || '—', desc: r.riskContent }));
});

const isUnqualified = computed(
  () =>
    taskDetail.value?.dataState == 0 &&
    taskDetail.value?.isOverdue == 0 &&
    +taskDetail.value?.superviseStatus !== 1
); // 数据检测不合格，系统拦截);

const repitImgIds = ref([]); // 重复图片id集合
const repitImgList = ref({}); // 重复图片

const showPreviewName = ref(
  props.projectType === 17 ? 'informationShow' : 'imgViewerShow'
);

const isPicRepeat = computed(() => {
  return !!Object.keys(repitImgIds.value).length;
});
const getRepitImgList = async () => {
  const { data } = await selectSimilartList({
    projectId: props.projectId,
    taskIdList: [props.id]
  });
  repitImgList.value = data || {};
  repitImgIds.value = Object.keys(repitImgList.value);
};
getRepitImgList();
const repeatPickurePerview = () => {
  createDialog({
    width: 1500,
    title: '图片重复关联项目',
    showClose: true,
    contentRender: () => {
      return (
        <div style="padding: 20px;">
          <RepeatPickure
            projectId={props.projectId}
            taskId={props.id}
            similarTaskIdList={repitImgList.value[props.id]}
          ></RepeatPickure>
        </div>
      );
    },
    beforeConfirm: async done => {
      done();
    }
  });
};

const auditShow = computed(() => {
  return props.canAudit && isAsp.value;
});

const compNames = computed(() => {
  return questionDetailComps(props.projectType);
});

function convertValuesToJsonArray(data: any[]): any[] {
  return data.map(item => {
    try {
      // 尝试将 values 字段解析为 JSON
      const parsedValues = JSON.parse(item.values);
      const parsedOptions = JSON.parse(item.optionJson);

      item.values = parsedValues;
      item.optionJson = parsedOptions;
    } catch (error) {
      // 如果解析失败，保持原样
    }
    return item;
  });
}
const taskDetail = ref<any>({});

const questionDetailInfo = computed(() => {
  return convertValuesToJsonArray(
    taskDetail.value?.questionnaireInFoDTOS || []
  );
});
// const body = document.body;

const showIndex = ref(0);
const emits = __emit;

const onChangeImgUrl = url => {
  // 查找url在于picList
  const index = picList.value.findIndex(item => item === url);
  onChangeActive(index);
  showPreviewName.value = 'imgViewerShow';
};

const onChangeActive = index => {
  showIndex.value = index;
};
const onAudit = async status => {
  useTaskAudit({
    auditStatus: status,
    projectId: props.projectId,
    queryParams: {
      sceneType: props.projectType,
      taskRecordId: [props.id]
    },
    auditOver() {
      emits('auditOver', taskDetail.value?.nextTaskId);
    }
  });
};

const onMapRefresh = async () => {
  await taskRecordUpdateMap({
    taskRecordId: props.id,
    projectId: props.projectId,
    sceneType: props.projectType
  });
  getTaskDetail();
};

const onDiffMap = () => {
  showPreviewName.value = 'deefMapShow';
};

const picList = ref([]); //图片列表

const initPicList = async () => {
  picList.value = [];
  // 协定服务
  if (props.projectType === 19) {
    const imageTypeReg = new RegExp(/\.bmp|\.jpg|\.png|\.gif|\.jpeg/, 'i');

    questionDetailInfo.value[0].values.forEach(item => {
      // item.url 后缀为图片则push
      if (imageTypeReg.test(item.url)) {
        picList.value.push(item.url);
      }
    });
  } else {
    questionDetailInfo.value.forEach(item => {
      if (item.topicType === -3) {
        item.values && picList.value.push(item.values);
      }
      if (item.topicType === 20) {
        item.values && picList.value.push(item.values);
      }

      if (item.topicType === 13) {
        item.values &&
          item.values.forEach(item => {
            picList.value.push(item.url);
          });
      }
      if (item.topicType === 16) {
        item.values &&
          item.values.addressPicUrl &&
          picList.value.push(item.values.addressPicUrl);
      }
    });
  }
  if (props.projectType !== 17 && !picList.value.length) {
    showPreviewName.value = '';
  }
};

watch(
  () => showIndex.value,
  () => {
    showPreviewName.value = '';
    nextTick(() => {
      showPreviewName.value = 'imgViewerShow';
    });
  }
);

const getTaskDetail = async () => {
  const { data } = await taskRecordDetail({
    id: props.id,
    dataState: props.dataState,
    projectId: props.projectId,
    sceneType: props.projectType,
    searchVal: props.searchVal
  });
  taskDetail.value = data;
  initPicList();
};
getTaskDetail();
const onClose = () => {
  props.remove();
};
const handleEsc = event => {
  if (event.key === 'Escape') {
    onClose();
  }
};
onMounted(async () => {
  window.addEventListener('keydown', handleEsc);
});
onUnmounted(() => {
  window.removeEventListener('keydown', handleEsc);
});

return (_ctx: any,_cache: any) => {
  const _directive_resource = _resolveDirective("resource")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", {
            onClick: onClose,
            style: {"cursor":"pointer"}
          }, [
            _createVNode(_unref(BaseSvg), {
              style: {"width":"20px","height":"20px"},
              iconClass: "close"
            })
          ])
        ]),
        _createElementVNode("div", {
          style: _normalizeStyle(auditShow.value ? 'height: calc(100vh - 160px)' : 'height: 100%'),
          class: "overlay-right-main"
        }, [
          _createElementVNode("div", null, [
            (isUnqualified.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
              : _createCommentVNode("", true),
            (isPicRepeat.value)
              ? (_openBlock(), _createBlock(_unref(BaseRow), {
                  key: 1,
                  style: {"padding":"5px 5px","text-align":"left"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, [
                      _hoisted_8,
                      _hoisted_9,
                      _hoisted_10,
                      _createTextVNode(" 标记任务记录内提交的图存在重复, "),
                      _createVNode(_unref(BaseButton), {
                        type: "text",
                        onClick: repeatPickurePerview,
                        style: {"color":"#409eff","text-decoration":"underline"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 点击查看 ")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", null, [
                _createTextVNode(_toDisplayString(taskDetail.value?.username || '-') + " ", 1),
                _hoisted_14,
                _createTextVNode(" " + _toDisplayString(taskDetail.value?.phone || '-'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("div", null, _toDisplayString(_unref(formatter).date(taskDetail.value?.editStatusAt)), 1)
            ]),
            (_ctx.projectType === 19)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("div", null, _toDisplayString(_unref(formatter).fen2yuan(taskDetail.value?.price)), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              (_ctx.projectType === 21)
                ? (_openBlock(), _createBlock(_unref(BaseButton), {
                    key: 0,
                    type: "primary",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (showPreviewName.value = 'informationShow'))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 查看资讯 ")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            (isAsp.value && aiConclusionData.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _hoisted_24,
                    _hoisted_25,
                    _createElementVNode("span", _hoisted_26, _toDisplayString(summaryTheme.value.icon) + " " + _toDisplayString(summaryTheme.value.label), 1)
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      (initTheme.value.label)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            _hoisted_30,
                            _createElementVNode("span", {
                              class: _normalizeClass(["ai-verdict", initTheme.value.cls])
                            }, [
                              _createElementVNode("span", _hoisted_31, _toDisplayString(initTheme.value.icon), 1),
                              _createTextVNode(" " + _toDisplayString(initTheme.value.label), 1)
                            ], 2),
                            _createElementVNode("div", _hoisted_32, _toDisplayString(aiInitSummary.value), 1),
                            _createElementVNode("div", _hoisted_33, " 审核时间：" + _toDisplayString(aiConclusionData.value?.aspAuditAt
                          ? _unref(formatter).date(aiConclusionData.value.aspAuditAt)
                          : '-'), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (finalBatchPill.value.label)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                            _hoisted_35,
                            _createElementVNode("span", {
                              class: _normalizeClass(["aia-pill", finalBatchPill.value.cls])
                            }, _toDisplayString(finalBatchPill.value.label), 3),
                            _createElementVNode("div", _hoisted_36, _toDisplayString(aiFinalSummary.value), 1),
                            _createElementVNode("div", _hoisted_37, " 审核时间：" + _toDisplayString(aiConclusionData.value?.ossAuditAt
                          ? _unref(formatter).date(aiConclusionData.value.ossAuditAt)
                          : '-'), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _hoisted_38,
            _createElementVNode("div", null, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(compNames.value), {
                isShowMapHandleBtn: _ctx.isShowMapHandleBtn,
                questionInfo: questionDetailInfo.value,
                onChangeImgUrl: onChangeImgUrl,
                onMapRefresh: onMapRefresh,
                onDiffMap: onDiffMap
              }, null, 40, ["isShowMapHandleBtn", "questionInfo"]))
            ])
          ])
        ], 4),
        (auditShow.value)
          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_39, [
              _createElementVNode("div", null, [
                _createVNode(_unref(BaseButton), {
                  disabled: 
                taskDetail.value?.buttonOnOff === 0 || taskDetail.value?.buttonOnOff === 2
              ,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (onAudit(2))),
                  plain: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 通过 ")
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_unref(BaseButton), {
                  disabled: taskDetail.value?.buttonOnOff === 0,
                  type: "default",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (onAudit(3))),
                  plain: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 不通过 ")
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ])), [
              [_directive_resource, ['任务记录_审核任务']]
            ])
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_40, [
        (showPreviewName.value === 'informationShow')
          ? (_openBlock(), _createBlock(CPreview, {
              key: 0,
              projectType: props.projectType,
              informationId: taskDetail.value?.informationId,
              projectId: props.projectId,
              taskId: props.id
            }, null, 8, ["projectType", "informationId", "projectId", "taskId"]))
          : _createCommentVNode("", true),
        (showPreviewName.value === 'imgViewerShow')
          ? (_openBlock(), _createBlock(_unref(BaseImageViewer), {
              key: 1,
              previewTeleported: true,
              infinite: true,
              "preview-src-list": picList.value,
              "initial-index": showIndex.value,
              "hide-close": true
            }, null, 8, ["preview-src-list", "initial-index"]))
          : _createCommentVNode("", true),
        (showPreviewName.value === 'deefMapShow')
          ? (_openBlock(), _createBlock(DeefMap, {
              key: 2,
              projectType: props.projectType,
              projectId: props.projectId,
              taskRecordId: props.id,
              dataState: taskDetail.value?.dataState
            }, null, 8, ["projectType", "projectId", "taskRecordId", "dataState"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})